// extracted by mini-css-extract-plugin
export default {"modal":"AlertModal_modal__MjaSG","overlay":"AlertModal_overlay__25tSf","title":"AlertModal_title__vaNnC","message":"AlertModal_message__cfK+Q"};